// '2.23.0' is replaced before publishing to npm at .github/workflows/publish_sdk.yml
export const SDK_VERSION = '2.23.0'
